import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, switchMap, tap } from 'rxjs/operators';
import { getMembershipOfferPriceQuery } from '@aaa/emember/store-membership-offers';
import { filter, of } from 'rxjs';
import { getIsLoadingPriceOffer, PriceOffersActions, PriceOffersQuery } from '@aaa/emember/store-price-offers';

export const forceLoadPrice: CanActivateChildFn = () => {
  const store = inject(Store);
  const load = (query: PriceOffersQuery) =>
    of(query).pipe(
      tap(() => store.dispatch(PriceOffersActions.load({ query }))),
      switchMap(() => store.select(getIsLoadingPriceOffer).pipe(filter((isLoading) => !isLoading))),
      map(() => true),
    );

  return store.select(getMembershipOfferPriceQuery).pipe(switchMap((query) => load(query)));
};

export default forceLoadPrice;
